import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { PreviewCardLeftSidebar, PreviewCardBody, PreviewCardWrapper, PreviewCardHeaderWrapper, PreviewCardContentTextWrapper, previewCardTheme } from './PreviewCardStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewCardSkeletonState = () => {
  return /*#__PURE__*/_jsxs(PreviewCardWrapper, {
    disabled: false,
    isSelected: false,
    isUnread: false,
    hideBulkSelectCheckbox: false,
    "data-test-id": "PreviewCardSkeletonState",
    children: [/*#__PURE__*/_jsx(PreviewCardLeftSidebar, {
      children: /*#__PURE__*/_jsx(SkeletonCircle, {
        size: previewCardTheme.AVATAR_SIZE
      })
    }), /*#__PURE__*/_jsxs(PreviewCardBody, {
      children: [/*#__PURE__*/_jsx(PreviewCardHeaderWrapper, {
        isUnread: false,
        children: /*#__PURE__*/_jsx(SkeletonText, {
          inlineSize: "70%"
        })
      }), /*#__PURE__*/_jsxs(PreviewCardContentTextWrapper, {
        isUnread: false,
        children: [/*#__PURE__*/_jsx(SkeletonText, {}), /*#__PURE__*/_jsx(SkeletonText, {
          inlineSize: "20%"
        })]
      })]
    })]
  });
};
PreviewCardSkeletonState.displayName = 'PreviewCardSkeletonState';
export default PreviewCardSkeletonState;